export function useString() {
    function snakeToTitle(value: string) {
        return value
            .split('_')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
    }

    return {
        snakeToTitle,
    }
}
